module.exports = __webpack_public_path__ + "images/dashboardIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboardIcon.png
// module id = 2126
// module chunks = 0